(() => {
    window.dataLayer = window.dataLayer || [];

    document.addEventListener("customer-state:loaded", (event) => {
      const variantInfo = event.detail?.variant || null;
      if (!variantInfo) return;

      const variantName = variantInfo.name;

      try {
        window.dataLayer.push({
          event: "experiment_impression",
          exp_variant_string: `silver-filter--segment-${variantName}`,
        });
      } catch (e) {
        console.error("[SEGMENT] g4a push error", e);
      }

      const filterValue = variantInfo.filter;
      if (!filterValue) return;
      initFilter(decodeURIComponent(filterValue));
    });

    function initFilter(filterValue) {
        // The payload value must be the S&D grouped-value LABEL ('Silber') or the
        // FilterSettingGroup gid — raw option values ('Silver') filter results but
        // do NOT activate the facet, so the server would render default card images
        // (see color-entity-refactor.md, Block C).
        const FILTER_KEY = 'filter.v.option.color';
        const FILTER = `${FILTER_KEY}=${encodeURIComponent(filterValue)}`;

        document.addEventListener(
            'click',
            (e) => {
                const a = e.target.closest?.('a[href*="/collections/"]');
                if (!a || a.closest('facet-remove')) return;

                const href = a.getAttribute('href');
                if (!href || href.includes(FILTER_KEY)) return;

                const hashIndex = href.indexOf('#');
                const hash = hashIndex !== -1 ? href.slice(hashIndex) : '';
                const base = hashIndex !== -1 ? href.slice(0, hashIndex) : href;
                a.setAttribute('href', `${base}${base.includes('?') ? '&' : '?'}${FILTER}${hash}`);
            },
            true
        );

        initSwatchAutoSelect();
    }

    function initSwatchAutoSelect() {
        // Card swatch inputs always carry the (English) option value, independent
        // of the segment payload / facet label — 'Silver' is correct here. Covers
        // the already-rendered landing page; subsequent navigations carry the
        // filter param and render silver server-side.
        const SELECTOR = '.variant-option__swatch input[value="Silver"]';

        const selectSilver = (root = document) => {
            root.querySelectorAll?.(SELECTOR).forEach((el) => {
                if (el.dataset.csfDone || el.checked) return;
                el.dataset.csfDone = '1';
                el.click();
                el.checked = true;

            });
        };

        const start = () => {
            selectSilver();
            new MutationObserver((mutations) => {
                for (const m of mutations) {
                    for (const node of m.addedNodes) {
                        if (node.nodeType === 1) selectSilver(node);
                    }
                }
            }).observe(document.body, { childList: true, subtree: true });
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', start);
        } else {
            start();
        }
    }
})();